// Create a global instance of GhostContentAPI
var ghostApi = null;
if (typeof epApiConfig !== 'undefined')
{
    ghostApi = new GhostContentAPI(epApiConfig);
}

jQuery(function() {
    if (typeof epApiConfig !== 'undefined')
    {
        function getRecipe(recipeSlug, element){
            ghostApi.posts.read({
                slug: recipeSlug
            })
            .then((post) => {
                var postHtml = post.html;

                // Get everything after the closing </nested-recipe-start> tag and before the start of the starting nested-recipe-end tag.
                // If post contains a start tag but not end tag then take everything after the start tag
                // If post contains an end tag but not a start tag then take everything up to the end tag.
                postHtml = postHtml.split('</nested-recipe-start>').pop();
                postHtml = postHtml.split('<nested-recipe-end>')[0];

                var recipeHtml = 
                    "<div class=\"recipelink single-content gh-content gh-canvas \">" + 
                        "<p>The quick recipe reference is below. For more information and photos, view the full " + 
                            "<a href=\"" + post.url + "\"> " + post.title + "</a> recipe page.</p>" 
                            + postHtml + 
                    "</div>"
                $(element).replaceWith(recipeHtml);
            })
            .catch((error) => {
                console.error(error);
            });
        }
    }

    $('recipe-placeholder').each(function(index, element) {
        var recipeSlug = element.innerHTML;
        getRecipe(recipeSlug, element);
    });

    $('nested-recipe-start').each(function(index, element) {
        element.replaceWith("");
    });

    $('nested-recipe-end').each(function(index, element) {
        element.replaceWith("");
    });

    function truncateWords(text, limit) {
        return text.split(' ').slice(0, limit).join(' ') + (text.split(' ').length > limit ? '…' : '');
    }

    async function fetchRelatedPostsByTags(tagsArray, currentPostId) {
        if (!tagsArray?.length){
            document.getElementById('related-posts-wrapper').style.display = 'none';
            return;
        }

        const tagFilters = `tags:[${tagsArray.join(',')}]`
        const filter = `${tagFilters}+id:-${currentPostId}`;

        try {
            const related = await ghostApi.posts.browse({
                filter: filter,
                limit: 10,
                include: 'tags',
                formats: 'html',
                fields: `title,url,reading_time,excerpt,feature_image`
            });
      
            const container = document.querySelector('#related-posts');
            if (!container || !related.length)
            {
                document.getElementById('#related-posts-wrapper').style.display = 'none';
                return;
            }
      
            const currentTagSet = new Set(tagsArray);

            const sortedPosts = related.sort((a, b) => {
                const aMatches = a.tags.filter(t => currentTagSet.has(t.slug)).length;
                const bMatches = b.tags.filter(t => currentTagSet.has(t.slug)).length;
                return bMatches - aMatches; // more matches first
            });

            sortedPosts.slice(0, 3).forEach(post => {
                const articleHtml = `
                <article class="feed post">
                    <div class="feed-image u-placeholder rectangle">
                        ${post.feature_image ? `
                            <img
                                class="s-object-fit"
                                src="${post.feature_image}"
                                sizes="(min-width: 576px) 160px, 90vw"
                                alt="${post.feature_image_alt || post.title}"
                                loading="lazy"
                            >` : ''}
                    </div>
                
                    <div class="feed-wrapper">
                        <h2 class="feed-title">${post.title}</h2>
                            ${post.excerpt ? `<div class="feed-excerpt">${truncateWords(post.excerpt, 30)}</div>` : ''}
                        
                            <div class="feed-right">
                                ${post.reading_time ? `<div class="feed-length">${post.reading_time} min read</div>` : ''}
                            </div>
                    </div>
                </div>
                <a class="u-permalink" href="${post.url}" aria-label="${post.title}"></a>
                </article>`;
            
            document.querySelector('#related-posts').innerHTML += articleHtml;
          });
        } catch (err) {
          console.error('Error fetching related posts:', err);
        }
      }

    if (typeof internalTags !== 'undefined' && Array.isArray(internalTags))
    {
        fetchRelatedPostsByTags(internalTags, currentPostId);
    } 
});